import RequestStatus from "types/general/requests/RequestStatus";
import { createSlice } from "@reduxjs/toolkit";
import { defaultDataTablePageSize } from "functions/tables/TableFunctions";
import { ITableData } from "types/backend_models/shared/ITableData";
import { IProduct } from "types/backend_models/products/IProduct";
import { createSetFetchDataPendingReducer, createSetFetchDataSuccesReducer, createSetFetchDataErrorReducer, createResetRequestStatusReducer, GenericDataState } from "../../generic/GenericDataReducers";

// GENERIC
const initialState: GenericDataState<ITableData<IProduct[]>> = {
	requestStatus: RequestStatus.idle,
	data: {
		results: [],
		currentPage: 1,
		pageCount: 0,
		pageSize: defaultDataTablePageSize,
		rowCount: 0
	},
	error: null
}

const slice = createSlice({
	name: "products",
	initialState: initialState,
	reducers: {
		setFetchProductsPending: createSetFetchDataPendingReducer(),
		setFetchProductsSucces: createSetFetchDataSuccesReducer(),
		setFetchProductsError: createSetFetchDataErrorReducer(),
		resetProductsFetchStatus: createResetRequestStatusReducer(),
	}
});

export const {
	setFetchProductsPending,
	setFetchProductsSucces,
	setFetchProductsError,
	resetProductsFetchStatus
} = slice.actions;

export default slice.reducer;